export const perf = {
    now: () => {
        if (typeof performance !== 'undefined' && performance.now) {
            return performance.now();
        }
        else {
            return new Date().getTime();
        }
    },
    mark: (name) => {
        if (typeof performance !== 'undefined' && performance.mark) {
            performance.mark(name);
        }
    },
    measure: (name, start, end) => {
        if (typeof performance !== 'undefined' && performance.measure) {
            performance.measure(name, start, end);
        }
    },
    getEntriesByName(url) {
        if (typeof performance !== 'undefined' && performance.getEntriesByName) {
            return performance.getEntriesByName(url);
        }
        return undefined;
    },
    getEntriesByType(type) {
        if (typeof performance !== 'undefined' && performance.getEntriesByType) {
            return performance.getEntriesByType(type);
        }
        return undefined;
    },
};
//# sourceMappingURL=performance.js.map